// State
export const state = () => ({
	loading: false,
	items: [],
	item: {}
})

// Actions
export const actions = {
	async gets({ commit }) {
		try {
			commit('loading', true)
			await this.$axios
				.get(`/faq`)
				.then((response) => {
					commit('setItems', response.data.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async get({ commit }, id) {
		try {
			commit('loading', true)
			await this.$axios
				.get(`/faq/${id}`)
				.then((response) => {
					commit('setItem', response.data.data)
					commit('loading', false)
				})
		} catch (error) {
			commit('loading', false)
		}
	},
	async delete({ commit, dispatch }, id) {
		try {
			commit('loading', true)
			const response = await this.$axios
				.delete(`/faq/${id}`)
				.then((response) => {
					commit('loading', false)
					dispatch('gets')
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
	async create({ commit }, data) {
		try {
			commit('loading', true)
			const response = await this.$axios
				.post(`/faq`, data)
				.then(async (response) => {
					commit('loading', false)
					const resData = response.data
					const message = await this.dispatch(
						'language-strings/tl',
						resData?.message
					)
					this.$toast.success(message)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
	async update({ commit }, form) {
		const data = { ...form }
		const { id } = data
		delete data.id
		try {
			commit('loading', true)
			const response = await this.$axios
				.put(`/faq/${id}`, data)
				.then((response) => {
					commit('loading', false)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
	async updateSequence({ commit }, form) {
		const data = [...form]
		try {
			commit('loading', true)
			const response = await this.$axios
				.put(`/faq/bulk-sequence`, data)
				.then(async (response) => {
					commit('loading', false)
					const resData = response.data
					const message = await this.dispatch(
						'language-strings/tl',
						resData?.message
					)
					this.$toast.success(message)
					return true
				})
			return response
		} catch (error) {
			commit('loading', false)
		}
	},
}

// Mutations
export const mutations = {
	loading(state, type) {
		state.loading = type
	},
	setItems(state, data) {
		state.items = data
	},
	setItem(state, data) {
		state.item = data
	}
}

// Getters
export const getters = {}